import { createAction, props } from '@ngrx/store';

const GET_ALL_ROLES = '[RolesInterim] Get All Roles';
const SET_ROLES = '[RolesInterim] Set Roles';
const CREATE_ROLE = '[RolesInterim] Create Role';
const UPDATE_ROLE = '[RolesInterim] Update Role';
const DELETE_ROLE = '[RolesInterim] Delete Role';
const SAVE_ROLE = '[RolesInterim] Save Role';
const DELETE_ROLE_SUCCESS = '[RolesInterim] Delete Role Success';
const DELETE_ROLE_FAILURE = '[RolesInterim] Delete Role Failure';
const UPDATE_ROLE_SUCCESS = '[RolesInterim] Update Role Success';
const UPDATE_ROLE_FAILURE = '[RolesInterim] Update Role Failure';
const CREATE_ROLE_SUCCESS = '[RolesInterim] Create Role Success';
const CLEAR_ROLES_STATE = '[RolesInterim] Clear Roles State';

const getAllRoles = createAction(
  GET_ALL_ROLES,
  props<{
    apiConstants: any;
    payloadWithPathVariables: {
      generationId: string;
      start: number;
      length: number;
      order: any[];
      removeUrlVariables: string[];
    };
  }>()
);

const setRoles = createAction(SET_ROLES, props<{ roles: any[] }>());

const createRole = createAction(
  CREATE_ROLE,
  props<{
    apiConstants: any;
    urlPathVariables: {
      appId: string;
      orgId: string;
      generationId: string;
      name: string;
      shortName: string;
      description: string;
    };
  }>()
);

const createRoleSuccess = createAction(CREATE_ROLE_SUCCESS, props<{ role: any }>());

const updateRole = createAction(
  UPDATE_ROLE,
  props<{
    apiConstants: any;
    urlPathVariables: {
      sid: string;
      createdBy: string;
      createdDate: Date;
      modifiedBy: string;
      modifiedDate: Date;
      recDeleted: false;
      appId: string;
      orgId: string;
      name: string;
      shortName: string;
      description: string;
      sysGen: false;
      technicalRole: false;
      generationId: string;
      generationType: string;
      approvalStatus: string;
    };
  }>()
);

const updateRoleSuccess = createAction(UPDATE_ROLE_SUCCESS, props<{ role: any }>());
const updateRoleFailure = createAction(UPDATE_ROLE_FAILURE);

const deleteRole = createAction(DELETE_ROLE, props<{ apiConstants: any; urlPathVariables: { roleId: string } }>());

const deleteRoleSuccess = createAction(DELETE_ROLE_SUCCESS, props<{ roleId: string }>());
const deleteRoleFailure = createAction(DELETE_ROLE_FAILURE, props<{ error: any }>());

const saveRole = createAction(SAVE_ROLE, props<{ role: any }>());

const clearRolesState = createAction(CLEAR_ROLES_STATE);

const RoleInterimActions = {
  getAllRoles,
  setRoles,
  createRole,
  updateRole,
  deleteRole,
  saveRole,
  deleteRoleSuccess,
  deleteRoleFailure,
  updateRoleSuccess,
  updateRoleFailure,
  createRoleSuccess,
  clearRolesState
};
export default RoleInterimActions;
